module.exports = __webpack_public_path__ + "img/mkinetikos-2.03e161a7.png";